module.exports = __webpack_public_path__ + "static/17th-c1209a69655d9ec1b40359df98777bdd.png";